import { render } from "./user.html?vue&type=template&id=2d16d81b&ts=true"
import script from "./user.ts?vue&type=script&lang=ts"
export * from "./user.ts?vue&type=script&lang=ts"

import "./user.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__